"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EVENT_MAP = {
    abort: "onAbort",
    blur: "onBlur",
    canplay: "onCanPlay",
    canplaythrough: "onCanPlayThrough",
    change: "onChange",
    click: "onClick",
    contextmenu: "onContextMenu",
    copy: "onCopy",
    cut: "onCut",
    dblclick: "onDoubleClick",
    drag: "onDrag",
    dragend: "onDragEnd",
    dragenter: "onDragEnter",
    dragleave: "onDragLeave",
    dragover: "onDragOver",
    dragstart: "onDragStart",
    drop: "onDrop",
    durationchange: "onDurationChange",
    emptied: "onEmptied",
    ended: "onEnded",
    error: "onError",
    focus: "onFocus",
    input: "onInput",
    keydown: "onKeyDown",
    keypress: "onKeyPress",
    keyup: "onKeyUp",
    load: "onLoad",
    loadeddata: "onLoadedData",
    loadedmetadata: "onLoadedMetadata",
    loadstart: "onLoadStart",
    mousedown: "onMouseDown",
    mouseenter: "onMouseEnter",
    mouseleave: "onMouseLeave",
    mousemove: "onMouseMove",
    mouseout: "onMouseOut",
    mouseover: "onMouseOver",
    mouseup: "onMouseUp",
    mousewheel: "onWheel",
    paste: "onPaste",
    pause: "onPause",
    play: "onPlay",
    playing: "onPlaying",
    progress: "onProgress",
    ratechange: "onRateChange",
    reset: "onReset",
    scroll: "onScroll",
    seekend: "onSeeked",
    seeking: "onSeeking",
    select: "onSelect",
    stalled: "onStalled",
    submit: "onSubmit",
    suspend: "onSuspend",
    timeupdate: "onTimeUpdate",
    touchcancel: "onTouchCancel",
    touchend: "onTouchEnd",
    touchmove: "onTouchMove",
    touchstart: "onTouchStart",
    volumechange: "onVolumeChange",
    waiting: "onWaiting",
    wheel: "onWheel",
};
/* Not specified
  "activate"
  "beforeactivate"
  "beforecopy"
  "beforecut"
  "beforedeactivate"
  "beforepaste"
  "cuechange"
  "deactivate"
  "invalid"
  "selectstart"
  "ariarequest"
  "command"
  "gotpointeCapturer"
  "lostpointeCapturer"
  "webkitfullscreenchange"
  "webkitfullscreenerror"
*/
//# sourceMappingURL=event.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@react-mdc/base/lib/event.js
// module id = ./node_modules/@react-mdc/base/lib/event.js
// module chunks = 1 2 3